import {figmaElement} from "../figma-tree";
const assetPathPrefix = "/static/assets/5871150e-664d-492a-adf4-1185d00ecb84";
const imgIconLucideChevronDown = `${assetPathPrefix}/20e45.svg`;

type ArchiveButtonProps = {
  className?: string;
  label?: string;
  state?: "Default";
  style?: "Primary" | "Secondary";
};

function ArchiveButton({ className, label = "强制通过", state = "Default", style = "Primary" }: ArchiveButtonProps) {
  const isSecondaryAndDefault = style === "Secondary" && state === "Default";
  return (
    <div className={className || `border-solid content-stretch flex gap-[var(--archive-space-8,8px)] h-[44px] items-center justify-center p-[var(--archive-space-8,8px)] relative rounded-[var(--archive-radius-4,4px)] w-[104px] ${isSecondaryAndDefault ? "border border-[var(--action-secondary,#626b78)]" : "border-[1.5px] border-[var(--archive-action-primary,#29465b)]"}`} id={isSecondaryAndDefault ? "node-8_13" : "node-8_5"}>
      {style === "Primary" && state === "Default" && (
        <p className="[word-break:break-word] font-['Noto_Sans_SC:Medium'] font-medium leading-[24px] relative shrink-0 text-[14px] text-[color:var(--archive-action-primary,#29465b)] whitespace-nowrap" data-node-id="8:6">
          {label}
        </p>
      )}
      {isSecondaryAndDefault && (
        <p className="[word-break:break-word] font-['Noto_Sans_SC:Medium'] font-medium leading-[24px] relative shrink-0 text-[14px] text-[color:var(--action-secondary,#626b78)] whitespace-nowrap" data-node-id="8:14">
          {label}
        </p>
      )}
    </div>
  );
}

type ArchiveFilterFieldProps = {
  className?: string;
  label?: string;
  value?: string;
};

function ArchiveFilterField({ className, label = "归档时间", value = "全部时间" }: ArchiveFilterFieldProps) {
  return (
    <div className={className || "content-stretch flex flex-col gap-[var(--archive-space-8,8px)] h-[72px] items-start relative w-[208px]"} data-node-id="94:269" data-name="Archive/FilterField">
      <p className="[word-break:break-word] font-['Noto_Sans_SC:Medium'] font-medium leading-[20px] relative shrink-0 text-[12px] text-[color:var(--archive-text-secondary,#8a929f)] whitespace-nowrap" data-node-id="94:270">
        {label}
      </p>
      <div className="bg-[var(--archive-bg-surface,white)] border border-[var(--archive-border-default,#e1e5eb)] border-solid content-stretch flex gap-[var(--archive-space-8,8px)] h-[44px] items-center overflow-clip px-[var(--archive-space-12,12px)] relative rounded-[var(--archive-radius-4,4px)] shrink-0 w-full" data-node-id="94:271" data-name="Control">
        <p className="[word-break:break-word] flex-[1_0_0] font-['Noto_Sans_SC:Regular'] font-normal leading-[24px] min-w-px relative text-[14px] text-[color:var(--archive-text-primary,#20242c)]" data-node-id="94:272">
          {value}
        </p>
        <div className="content-stretch flex h-[16px] items-center justify-center overflow-clip relative shrink-0" data-node-id="94:273" data-name="Icon/Lucide/chevron-down">
          <div className="relative shrink-0 size-[16px]" data-node-id="275:2982" data-name="Icon/Lucide/chevron-down">
            <img alt="" className="absolute block inset-0 max-w-none size-full" src={imgIconLucideChevronDown} />
          </div>
        </div>
      </div>
    </div>
  );
}

export default function Component73() {
  return (
    <div className="bg-[var(--archive-bg-surface,white)] border border-[var(--archive-border-default,#e1e5eb)] border-solid content-stretch flex flex-col gap-[var(--archive-space-16,16px)] items-start overflow-clip p-[var(--archive-space-24,24px)] relative rounded-[var(--archive-radius-8,8px)] size-full" data-node-id="246:2691" data-name="73 / 人工审核 · 退回补交">
      <p className="[word-break:break-word] font-['Noto_Sans_SC:Bold'] font-bold leading-[28px] relative shrink-0 text-[20px] text-[color:var(--archive-text-primary,#20242c)] w-[512px]" data-node-id="249:2433">
        退回补交
      </p>
      <p className="[word-break:break-word] font-['Noto_Sans_SC:Regular'] font-normal leading-[24px] relative shrink-0 text-[14px] text-[color:var(--archive-text-secondary,#8a929f)] w-[512px]" data-node-id="249:2434">
        请明确需要补交的文书与原因，律师会看到以下内容。
      </p>
      <ArchiveFilterField className="content-stretch flex flex-col gap-[var(--archive-space-8,8px)] h-[72px] items-start relative shrink-0 w-[512px]" label="需要补交的文件名称 *" value="二审答辩状" />
      <ArchiveFilterField className="content-stretch flex flex-col gap-[var(--archive-space-8,8px)] h-[72px] items-start relative shrink-0 w-[512px]" label="审核意见 *" value="合同包含二审代理，原材料中未见二审答辩状。" />
      <p className="[word-break:break-word] font-['Noto_Sans_SC:Regular'] font-normal leading-[20px] relative shrink-0 text-[12px] text-[color:var(--archive-text-secondary,#8a929f)] w-[512px]" data-node-id="249:2447">
        原材料和已标注目录保留；补交后进入负责人复核。
      </p>
      <div className="content-stretch cursor-pointer flex gap-[var(--archive-space-12,12px)] h-[40px] items-start overflow-clip p-[var(--archive-space-0,0px)] relative shrink-0 w-[512px]" data-node-id="249:2448" data-name="Actions">
        <ArchiveButton className="border border-[var(--action-secondary,#626b78)] border-solid content-stretch flex gap-[var(--archive-space-8,8px)] h-[40px] items-center justify-center p-[var(--archive-space-8,8px)] relative rounded-[var(--archive-radius-4,4px)] shrink-0 w-[128px]" label="继续审核" style="Secondary" />
        <ArchiveButton className="border-[1.5px] border-[var(--archive-action-primary,#29465b)] border-solid content-stretch flex gap-[var(--archive-space-8,8px)] h-[40px] items-center justify-center p-[var(--archive-space-8,8px)] relative rounded-[var(--archive-radius-4,4px)] shrink-0 w-[144px]" label="确认退回" />
      </div>
    </div>
  );
}
